// SBA PDP — variant selector, qty stepper, sticky ATC, size guide modal, wishlist
(function() {
  'use strict';

  function fmt(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return v + ' €';
  }

  function bindVariants(section) {
    var variantsScript = section.querySelector('[data-sba-variants]') || document.querySelector('[data-sba-variants]');
    if (!variantsScript) return;
    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    var variantIdInput = section.querySelector('[data-sba-variant-id]');
    var priceEl = section.querySelector('[data-sba-price]');
    var priceOldEl = section.querySelector('[data-sba-price-old]');
    var saleTagEl = section.querySelector('[data-sba-sale-tag]');
    var installmentEl = section.querySelector('[data-sba-installment]');
    var atcBtn = section.querySelector('[data-sba-atc]');
    var atcLabel = section.querySelector('[data-sba-atc-label]');
    var atcPrice = section.querySelector('[data-sba-atc-price]');
    var stockEl = section.querySelector('[data-sba-stock]');
    var stickyPrice = section.querySelector('[data-sba-sticky-price]');

    function updateOptionLabels() {
      section.querySelectorAll('[data-sba-option-value]').forEach(function(el, i) {
        var radios = section.querySelectorAll('input[name="opt-' + (i + 1) + '"]');
        radios.forEach(function(r) { if (r.checked) el.textContent = r.value; });
      });
    }

    function getSelectedOptions() {
      var opts = [];
      var i = 1;
      while (true) {
        var radios = section.querySelectorAll('input[name="opt-' + i + '"]');
        if (!radios.length) break;
        var chosen = null;
        radios.forEach(function(r) { if (r.checked) chosen = r.value; });
        opts.push(chosen);
        i++;
      }
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function(v) {
        for (var i = 0; i < opts.length; i++) {
          if (v.options[i] !== opts[i]) return false;
        }
        return true;
      });
    }

    function update() {
      var opts = getSelectedOptions();
      var v = findVariant(opts);
      updateOptionLabels();
      if (!v) {
        if (atcBtn) { atcBtn.disabled = true; if (atcLabel) atcLabel.textContent = 'COMBINAISON INDISPONIBLE'; }
        return;
      }
      if (variantIdInput) variantIdInput.value = v.id;
      if (priceEl) priceEl.textContent = fmt(v.price);
      if (priceOldEl) {
        priceOldEl.textContent = v.compare_at_price ? fmt(v.compare_at_price) : '';
        priceOldEl.style.display = v.compare_at_price && v.compare_at_price > v.price ? '' : 'none';
      }
      if (saleTagEl) saleTagEl.style.display = v.compare_at_price && v.compare_at_price > v.price ? '' : 'none';
      if (installmentEl) installmentEl.textContent = fmt(Math.round(v.price / 4));
      if (stickyPrice) stickyPrice.textContent = fmt(v.price);
      if (atcPrice) atcPrice.textContent = fmt(v.price);
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        if (atcLabel) atcLabel.innerHTML = v.available ? ('AJOUTER AU PANIER &mdash; <span data-sba-atc-price>' + fmt(v.price) + '</span>') : 'RUPTURE DE STOCK';
      }
      if (stockEl) {
        if (v.available && v.inventory_quantity > 0 && v.inventory_quantity < 5) {
          stockEl.textContent = 'Plus que ' + v.inventory_quantity + ' en ' + v.title;
        } else if (!v.available) {
          stockEl.innerHTML = '<span class="sba-pdp__stock-out">Rupture de stock</span>';
        } else {
          stockEl.textContent = '';
        }
      }
      if (v.featured_image && v.featured_image.position) {
        var gallery = section.querySelector('[data-sba-gallery]');
        var targetItem = gallery && gallery.querySelector('[data-img-index="' + (v.featured_image.position - 1) + '"]');
        if (targetItem && gallery && targetItem !== gallery.firstElementChild) {
          gallery.prepend(targetItem);
          if (gallery.scrollWidth > gallery.clientWidth) {
            gallery.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            targetItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }
      }
    }

    section.querySelectorAll('[data-sba-opt-idx]').forEach(function(r) {
      r.addEventListener('change', update);
    });
  }

  function bindQty(section) {
    var qtyInput = section.querySelector('[data-qty-input]');
    var qtyMinus = section.querySelector('[data-qty-minus]');
    var qtyPlus = section.querySelector('[data-qty-plus]');
    if (!qtyInput) return;
    if (qtyMinus) qtyMinus.addEventListener('click', function(e) {
      e.preventDefault();
      qtyInput.value = Math.max(1, (+qtyInput.value || 1) - 1);
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function(e) {
      e.preventDefault();
      qtyInput.value = Math.min(10, (+qtyInput.value || 1) + 1);
    });
  }

  function bindStickyAtc(section) {
    var stickyBtn = section.querySelector('[data-sba-sticky-atc-btn]');
    var stickyBar = section.querySelector('[data-sba-sticky-atc]');
    var gallery = section.querySelector('[data-sba-gallery]');
    var form = section.querySelector('[data-sba-form]');
    if (stickyBar && gallery) {
      var onScroll = function() {
        var rect = gallery.getBoundingClientRect();
        if (rect.bottom < 100) stickyBar.classList.add('is-visible');
        else stickyBar.classList.remove('is-visible');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', function() {
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }
  }

  function bindSizeGuide(section) {
    var trigger = section.querySelector('[data-sba-size-guide]');
    var modal = section.querySelector('[data-sba-size-modal]');
    if (!trigger || !modal) return;
    var closes = section.querySelectorAll('[data-sba-size-close]');
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    });
    closes.forEach(function(c) {
      c.addEventListener('click', function(e) {
        e.preventDefault();
        modal.hidden = true;
        document.body.style.overflow = '';
      });
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !modal.hidden) {
        modal.hidden = true;
        document.body.style.overflow = '';
      }
    });
  }

  function bindWishlist(section) {
    var WL_KEY = 'sba_wishlist';
    function load() {
      try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch (e) { return []; }
    }
    function save(list) {
      try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) {}
    }
    var btns = section.querySelectorAll('[data-sba-wishlist]');
    if (!btns.length) return;
    var handle = section.getAttribute('data-product-handle');
    if (!handle) return;
    function refresh() {
      var list = load();
      var on = list.indexOf(handle) !== -1;
      btns.forEach(function(b) {
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('is-active', on);
        var label = b.querySelector('[data-sba-wishlist-label]');
        if (label) label.textContent = on ? 'Retirer de la liste' : 'Ajouter à la liste';
      });
    }
    refresh();
    btns.forEach(function(b) {
      b.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var list = load();
        var idx = list.indexOf(handle);
        if (idx === -1) list.push(handle);
        else list.splice(idx, 1);
        save(list);
        refresh();
      });
    });
  }

  function init(section) {
    try { bindQty(section); } catch (e) { console.warn('SBA qty bind failed', e); }
    try { bindSizeGuide(section); } catch (e) { console.warn('SBA size guide bind failed', e); }
    try { bindWishlist(section); } catch (e) { console.warn('SBA wishlist bind failed', e); }
    try { bindStickyAtc(section); } catch (e) { console.warn('SBA sticky ATC bind failed', e); }
    try { bindVariants(section); } catch (e) { console.warn('SBA variants bind failed', e); }
  }

  function start() {
    document.querySelectorAll('.sba-pdp').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
